import React from 'react';
import "./CertificatePages.module.css"
import { useNavigate, useLocation } from "react-router-dom";



import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';

const CertificateInformation = () => {
  const navigate = useNavigate();
  const location = useLocation();


  const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array
  const coursetrack = location.state ? location.state.courseTrack : "";
  const coursename = location.state ? location.state.courseName : "";

  //include css 
  const toggle = (id) => {
    setOpen(prevOpen => {
      if (prevOpen.includes(id)) {
        // If the section is already open, remove it from the open state
        return prevOpen.filter(item => item !== id);
      } else {
        // If the section is not open, add it to the open state
        return [...prevOpen, id];
      }
    });
  };
  const handleEnrollClick = (event) => {


    navigate("/application-form", {
      state: {
        courseTrack: coursetrack,
        courseName: coursename,

      },
    });
  };

  return (
    

    <div className="container mt-1 p-3 mb-1 " >
      {/* <h2>Certificate in Information Technology</h2> */}

      <Row>
        <Col>
          <h2 className=" text-center" style={{ color: '#123fae' }}>
            Certificate in Information Technology
            {/* <a href='a'
              style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
              className="d-block mx-auto"
              onClick={(event) => {
                event.preventDefault(); // Prevents the default behavior (page reload)
                handleEnrollClick(); // Calls your handleEnrollClick function
              }}
            >
              Register Now
            </a> */}

          </h2>




        </Col>
      </Row>


      {/* <h4>Course Details:</h4> */}
      <Row>


        <Col md={6} xs={12} className="mt-3 " >
          <Card style={{  marginTop: "5" }}>
            <CardHeader >
              Course Details:
            </CardHeader>



            <ListGroup flush >

              <ListGroupItem>
                Language: English
              </ListGroupItem>
              <ListGroupItem>
                Duration: 132 hours (3 months)
              </ListGroupItem>
              <ListGroupItem>
                Learning Mode: Online
              </ListGroupItem>
              <ListGroupItem>
                Certificate of Completion
              </ListGroupItem>


            </ListGroup>
          </Card  ></Col>

        <Col md={6} xs={12} className="mt-3 ">
          <Card style={{ minHeight: "100%" }}>
            <CardHeader >
              Eligibility:
            </CardHeader>




            <ListGroup flush className="px-2">

              <ListGroupItem>
                <li>Learner should preferably be a 12th std. Pass student.</li>

              </ListGroupItem>

            </ListGroup>
          </Card></Col>
      </Row>
      <br />
      <hr />

      <h5 style={{ position: "relative" }}>
        <span >
          &#x1F449;
        </span>
        Why Certificate in Information Technology
      </h5>
      <p>
        Certificate In Information Technology is an Information Technology (IT) literacy course started by HKCL in the year 2014. It is the most popular IT Literacy course in Haryana. In the 21st Century, most of the new actionable knowledge is being digitally born (often through digital collaborations), digitally stored, digitally presented, digitally distributed, digitally accessed, digitally archived and managed. It only seems natural that it has become an essential part of one's personal, professional, and social life. It has also transformed the way of living in the 21st Century.
      </p>
      <hr />

      <h5 style={{ left: "0" }}>Certification</h5>
      <p>Certificate In Information Technology course is jointly certified by CDOE, GJUST and HKCL.</p>
      {/* <hr />
      <h5 style={{ left: "0" }}>Important Dates:</h5>
      <ul>
        <li>Batch Commencement: One batch in each calendar month (January to December)</li>
        <li>Date(s) of Application and Fee Payment by Learner: 1st - 30th day of each calendar month.</li>
        <li>Date(s) of Learner Confirmation: 1st - 30th day of each calendar month.</li>
      </ul> */}
      <hr />
      <h5 style={{ left: "0" }}>Academic Approach</h5>
      <p>
        The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
        Learning methodology:
      </p>


      <ul>
        <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
        <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
        <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
        <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
        <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
        <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
        <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
        <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
        <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
        <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
        <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
        <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
      </ul>
      <hr />

      <h5 style={{ left: "0" }}>Admission Guidelines</h5>
      <p>
       
        <ol>
          <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
          
        </ol>
      </p>
      <hr />


      <h5>Syllabus</h5>


      <Accordion open={open} toggle={toggle} className="mb-2" >
        <AccordionItem>
          <AccordionHeader targetId="7">Basic IT Awareness</AccordionHeader>
          <AccordionBody accordionId="7">
            <div style={{ overflowX: 'auto' }}>

              <Table bordered >
                <thead>
                  <tr>
                    <th>Topics</th>
                    <th>Sub-Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Computer Basics</td>
                    <td>
                      <ul>
                        <li>Describe the importance of computers in today's world.</li>
                        <li>Identify the main parts of a computer.</li>
                        <li>Identify the steps for starting and shutting down a computer.</li>
                        <li>Identify the different groups of keys on a keyboard.</li>
                        <li>Basic typing, typing in multiple languages.</li>
                        <li>Perform different tasks by using a mouse.</li>
                        <li>Describe other common computing devices such as laptops, netbooks, Tablets, and phones.</li>
                        <li>Identify the primary hardware components of a computer.</li>
                        <li>Explain an operating system.</li>
                        <li>Explain programs and data.</li>
                        <li>Describe a network and the types of networks.</li>
                        <li>Explain the terms Internet, World Wide Web, and intranet.</li>
                        <li>Compare the features of different types of computers.</li>
                        <li>Explain the role of memory.</li>
                        <li>Explain the basics of computer performance.</li>
                        <li>Explain the concept of minimum requirements for software.</li>
                        <li>Describe the types of productivity programs and their uses.</li>
                        <li>Describe the types of communications programs and their uses.</li>
                        <li>Describe the uses of educational and entertainment programs.</li>
                        <li>Explain the common functions of an operating system.</li>
                        <li>Identify the components of the Windows 10 interface.</li>
                        <li>Explain the options available in the Start screen of Windows 10.</li>
                        <li>Work with the Windows 10 interface within programs.</li>
                        <li>Manage files and folders in Windows Explorer.</li>
                        <li>Perform basic file operations.</li>
                        <li>Describe how computers have become a central part of everyday rural and urban life – around the world.</li>
                        <li>Identify the career opportunities available for a computer-literate person.</li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td>The Internet, and<br></br> the World Wide Web</td>
                    <td>
                      <ul>
                        <li>Describe the uses of the Internet and Cloud Services.</li>
                        <li>Identify the requirements for an Internet connection.</li>
                        <li>Identify the features of two types of Internet connections.</li>
                        <li>Describe the components of the Web.</li>
                        <li>Explain how Web addresses work.</li>
                        <li>Explain how to connect to the Internet.</li>
                        <li>Explore Web sites by using a browser.</li>
                        <li>Describe how to save favorite Web sites.</li>
                        <li>Search for reliable information on the Web.</li>
                        <li>Explain how to perform transactions over the Web.</li>
                        <li>Explain how e-mail works.</li>
                        <li>Write and send e-mail messages.</li>
                        <li>Manage e-mail messages.</li>
                        <li>Identify correct e-mail etiquette</li>
                        <li>How to create an email address.</li>
                        <li>Identify the features of online communities.</li>
                        <li>Explain how instant messaging and Web-cam video communication works.</li>
                        <li>Explain how to create and publish Web pages.</li>
                        <li>Explain how to blog using Windows Live Writer.</li>

                      </ul>

                    </td>
                  </tr>
                  <tr>
                    <td>Information Technology,<br></br> The Internet, and You</td>
                    <td>
                      <ul>
                        <li>Information Systems</li>
                        <li>People</li>
                        <li>Software</li>
                        <li>Hardware</li>
                        <li>Data</li>
                        <li>Connectivity and the Mobile Internet</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>The Internet, the Web <br></br>and Electronic Commerce </td>
                    <td>
                      <ul>
                        <li>The Internet and the Web</li>
                        <li>Internet Access</li>
                        <li>Web Utilities (Filters, File transfer utilities, Internet Security Suites)</li>
                        <li>Communication</li>
                        <li>Search Tools</li>
                        <li>Electronic Co</li>
                        <li>Cloud Computi</li>
                        <li>The Internet </li>

                      </ul>
                    </td>
                  </tr>
                  {/* <tr>
                  <td>Electronic Commerce </td>
                  <td>
                    <ul>
                      <li>Communication</li>
                      <li>Search Tools</li>
                      <li>Electronic Co</li>
                      <li>Cloud Computi</li>
                      <li>The Internet </li>


                    </ul>
                  </td>
                </tr> */}
                  <tr>
                    <td>Application Software </td>
                    <td>
                      <ul>
                        <li>Application Software</li>
                        <li>General-Purpose Applications</li>
                        <li>Specialized Applications </li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>System Software </td>
                    <td>
                      <ul>
                        <li>System Software</li>
                        <li>Operating systems</li>
                        <li>Mobile Operating systems</li>
                        <li>Desktop Operating systems</li>
                        <li>Utilities</li>


                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>The System Unit </td>
                    <td>
                      <ul>
                        <li>System Unit</li>
                        <li>System Board</li>
                        <li>Microprocessor</li>
                        <li>Memory</li>
                        <li>Expansion Slots and Cards</li>
                        <li>Bus Lines</li>
                        <li>Ports</li>
                        <li>Power Supply</li>
                        <li>Electronic Data and Instructions</li>



                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Input and Output </td>
                    <td>
                      <ul>
                        <li>What is Input?</li>
                        <li> Keyboard Entry</li>
                        <li>Pointing Devices</li>
                        <li>Scanning Devices</li>
                        <li>Image Capturing Devices</li>
                        <li>Audio-Input Devices</li>
                        <li>What is Output?</li>
                        <li>Monitors</li>
                        <li> Printers</li>
                        <li> Audio-Output Devices</li>
                        <li> Combination Input and Output devices</li>

                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td>Secondary Storage </td>
                    <td>
                      <ul>
                        <li>Storage</li>
                        <li>Hard Disks</li>
                        <li>Solid State Storage</li>
                        <li>Optical Discs</li>
                        <li>Cloud Storage</li>
                        <li>Mass Storage Devices</li>

                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td>Communications and Networks </td>
                    <td>
                      <ul>
                        <li>Communications</li>
                        <li> Communication Channels</li>
                        <li>Connections Devices</li>
                        <li> Data Transmission</li>
                        <li>Networks</li>
                        <li>Network Types</li>
                        <li> Network Architecture</li>
                        <li>Organizational Networks</li>
                        <li>Data</li>


                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Databases </td>
                    <td>
                      <ul>
                        <li>Data Organization</li>
                        <li> Databases</li>
                        <li> DBMS Structure</li>
                        <li>Types of Databases</li>
                        <li> Database Uses and Issues</li>


                      </ul>
                    </td>
                  </tr>


                </tbody>
              </Table>
            </div>

          </AccordionBody>
        </AccordionItem>
      </Accordion>
      {/* <h4>Basic IT Awareness</h4> */}

      <Accordion open={open} toggle={toggle} className="mb-2">
        <AccordionItem>
          <AccordionHeader targetId="8">Smart Typing Skills</AccordionHeader>
          <AccordionBody accordionId="8">
            <div style={{ overflowX: 'auto' }}>
              <Table bordered>
                <thead>
                  <tr>
                    <th>Topics</th>
                    <th>Sub-Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Introduction</td>
                    <td>
                      <ul>
                        <li> Introduction to Typing</li>
                        <li>Touch Typing</li>
                        <li>Voice Typing</li>
                        <li>Keyboard</li>
                        <li>Types of Keyboards</li>
                        <li> Ergonomic Keyboards</li>
                        <li> PDA Keyboards</li>
                        <li> Devanagari Font and complex script settings, Unicode settings</li>
                        <li> Muscle Memory</li>
                        <li> Names of Fingers</li>
                        <li> Finger Placements</li>
                        <li> Minimizing Hand Movements</li>
                        <li> Typing Trivia</li>
                        <li>Measuring Progress</li>

                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td>Introduction to Keyboard</td>
                    <td>
                      <ul>
                        <li>Introduction to Keyboard, Home Row</li>
                        <li>The Space Bar</li>
                        <li>The Enter Key</li>
                        <li> Using Keys</li>
                        <li>Typing Tips</li>
                        <li> Learning the G and H Keys</li>
                        <li> Learning the Apostrophe Key</li>
                        <li> Top Row</li>
                        <li> Learning the E and I Keys</li>
                        <li>Learning the W and O Keys</li>
                        <li> Learning the Q and Y Keys</li>
                        <li> Learning the P and T Keys</li>
                        <li>Bottom Row</li>
                        <li>Learning the C and Comma Keys</li>
                        <li> Learning the Tab Key</li>


                      </ul>

                    </td>
                  </tr>
                  <tr>
                    <td>Introduction to Number Pad</td>
                    <td>
                      <ul>
                        <li>Num Pad</li>
                        <li>Touch Typing on the Number Pad</li>
                        <li> Num Pad Home Row Positions</li>
                        <li> Index Finger Keys</li>
                        <li> Typing Tips</li>
                        <li>Learning the X and Period Keys</li>
                        <li> Learning the Z and Slash Keys</li>
                        <li> Learning the B and N Keys</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Other Keys </td>
                    <td>
                      <ul>
                        <li>Other Keys, Numbers and Symbols</li>
                        <li>Shift Keys</li>


                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Number and Symbols </td>
                    <td>
                      <ul>
                        <li>Numbers</li>
                        <li> Using Number Keys – 1 to 5</li>
                        <li>Using Number Keys – 6 to 9 and zero</li>
                        <li> Symbols</li>
                        <li>Learning the Square Brackets and Back Slash Keys</li>
                        <li>Navigation Keys</li>
                        <li>End Key</li>
                        <li>Page Up and Page Down Keys</li>
                        <li> Arrow Keys</li>
                        <li>Other Keys</li>
                        <li>Esc Key</li>
                        <li>Windows Key</li>
                        <li> Special Keys</li>
                        <li> Caps Lock</li>
                        <li>Numeric Keypad</li>
                        <li>Middle Finger Keys</li>
                        <li>Ring Finger Keys</li>
                        <li> Little Finger Keys</li>



                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Data Entry in Various Tools </td>
                    <td>
                      <ul>
                        <li> Microsoft Excel 2019</li>
                        <li>Creating a Workbook</li>
                        <li>Using Templates</li>
                        <li>Downloading Templates</li>
                        <li> Creating a Blank Workbook</li>
                        <li> Moving Between Cells</li>
                        <li>Entering Headings</li>
                        <li>Entering Data</li>
                        <li>Adjusting Column Width</li>
                        <li>Open Office Writer</li>
                        <li> Creating a New Document</li>
                        <li>Entering Text</li>
                        <li> Text Wrapping and Tabs</li>
                        <li>Selecting Text</li>
                        <li> Editing Text</li>
                        <li>Undoing and Redoing</li>
                        <li> Editing Modes</li>
                        <li> Open Office Calc</li>
                        <li>Creating a Spreadsheet</li>
                        <li>Moving Between Cells</li>
                        <li> Entering Headings</li>
                        <li> Entering Data</li>
                        <li> Adjusting Column Width</li>
                        <li> Google Docs</li>
                        <li> Adobe PageMaker</li>
                        <li>CorelDRAW</li>
                        <li> Adobe InDesign</li>
                        <li>Data Entry</li>
                        <li> Role of a Data Entry Operator</li>
                        <li> Need for Data Conversion</li>
                        <li> Skills Required for Data Entry</li>
                        <li> Types of Data Entry Jobs</li>
                        <li> Data Entry Jobs in Industrial Sector</li>
                        <li> Data Entry Jobs in Medical Sector</li>
                        <li> Related Jobs</li>
                        <li> Types of Data</li>
                        <li> Data Validation</li>
                        <li> Data Categories</li>
                        <li> Data Correctness</li>
                        <li> Compiling Data</li>
                        <li> Data Entry Tools</li>


                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Data Conversion, Scanning<br></br> and Image Assisted Data Entry </td>
                    <td>
                      <ul>
                        <li> Scanning</li>
                        <li>OCR</li>
                        <li>Data Conversion for the Web</li>
                        <li>Other Conversions</li>
                        <li>Data Entry Pay Scales</li>
                        <li>Factors affecting Pay Scale</li>



                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Copyrights and document formats </td>
                    <td>
                      <ul>
                        <li>Copyright</li>
                        <li> Legal Documents and Stamp Papers</li>
                        <li> Other Documents</li>
                        <li>Medical Transcription</li>
                        <li>How Transcription Works</li>
                        <li> Medical Transcription Course</li>
                        <li>Stamp Papers</li>
                        <li>Bank Documents</li>
                        <li>KYC Details</li>
                        <li> Loan Applications</li>
                        <li>Form Entries</li>
                        <li> Form Entry</li>
                        <li> Publications</li>
                        <li> Types of Typists</li>
                        <li> More Information</li>
                        < li> Typewriters To Computers</li>



                      </ul>
                    </td>
                  </tr>



                </tbody>
              </Table>
            </div>

          </AccordionBody>
        </AccordionItem>
        <AccordionItem></AccordionItem>
      </Accordion>

      {/* <h4>Smart Typing Skills</h4> */}

      <Accordion open={open} toggle={toggle} className="mb-2">
        <AccordionItem>
          <AccordionHeader targetId="9">21st Century Office Productivity Skills</AccordionHeader>
          <AccordionBody accordionId="9">
            <div style={{ overflowX: 'auto' }}>
              <Table bordered>
                <thead>
                  <tr>
                    <th>Topics</th>
                    <th>Sub-Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Office Productivity Programs – MS Office<br></br> (Word, Excel, PowerPoint) and <br></br>Google Office (Docs, Sheets, Slides)</td>
                    <td>
                      <ul>
                        <li>Describe the functionality of the common programs in Microsoft Office 2019 and Office Web Apps.</li>
                        <li>Identify the main components of the graphical user interface (GUI) of a productivity program.</li>
                        <li>Use the pointer to navigate in a program.</li>
                        <li>Identify the tabs, groups, and commands on the Ribbon.</li>
                        <li>Use the buttons on the toolbars to perform various tasks.</li>
                        <li>Type text and characters in a program by using the keyboard.</li>
                        <li>Explain the use of keyboard shortcuts and key combinations.</li>
                        <li>Perform basic tasks in a word processor.</li>
                        <li>Find and open templates in word processor.</li>
                        <li>Edit and format text in word processor.</li>
                        <li>Work with Tables and pictures in word processor.</li>
                        <li>Proofread a document in a word processor.</li>
                        <li>Identify the benefits of desktop publishing.</li>
                        <li>Identify the components of a spreadsheet.</li>
                        <li>Enter data into a spreadsheet.</li>
                        <li>Perform basic mathematical tasks in a spreadsheet.</li>
                        <li> Insert charts in a spreadsheet.</li>
                        <li>Print a spreadsheet.</li>
                        <li>Identify the elements of a presentation program.</li>
                        <li> Create a presentation.</li>
                        <li>Add graphics and multimedia to a presentation.</li>
                        <li>Use the print options available in a presentation program.</li>
                        <li> Explain basic concepts of a database.</li>
                        <li>Create a database.</li>
                        <li>Work with records in a database.</li>
                        <li>Explain what database queries are and how they work.</li>
                        <li>Work with reports.</li>


                      </ul>
                    </td>
                  </tr>






                </tbody>
              </Table>
              <h4>21st Century Daily Life Skills </h4>
              <Table bordered>
                <thead>
                  <tr>
                    <th>Topics</th>
                    <th>Sub-Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Internet and Connectivity</td>
                    <td>
                      <ul>
                        <li> Buying good internet plans for mobile</li>
                        <li> Configure and activate internet connection for mobile</li>
                        <li>Wi-Fi</li>
                        <li>Tethering, Hotspot</li>



                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>Productivity</td>
                    <td>
                      <ul>
                        <li> Mobile Number Identification :Truecaller App</li>
                        <li>Google Tasks</li>
                        <li> Google Calendar</li>
                        <li>To-Do, reminders, Alarms, Clock</li>
                        <li>Gmail</li>
                        <li>Voice Typing</li>
                        <li>Smart Voice Assistant: Google Assistant, Siri</li>
                        <li>Weather forecast: Accuweather</li>
                        <li>JustDial</li>
                        <li>Mobile Scanners (Adobe Scanner, Google Lens)</li>
                        <li> Evernote</li>
                        <li> QR code scanning</li>
                        <li>Google Docs, Google Slides, Google Sheets, Google Drive</li>
                        <li> Google Playbooks</li>
                        <li> Voice Recorder</li>
                        <li> Mirroring Apps</li>
                        <li> Minutes of meetings: Otter</li>
                        <li> Google Keep</li>
                        <li> Android File Explorer</li>
                        <li>DropBox</li>
                        <li> Camera (Photo, Video)</li>




                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>Social Connect</td>
                    <td>
                      <ul>
                        <li>Networking for professional upgradation: LinkedIn</li>
                        <li>Google Duo</li>
                        <li>Skype</li>
                        <li>Google Meet</li>
                        <li>WhatsApp</li>




                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>Social Connect</td>
                    <td>
                      <ul>
                        <li>Networking for professional upgradation: LinkedIn</li>
                        <li>Google Duo</li>
                        <li>Skype</li>
                        <li>Google Meet</li>
                        <li>WhatsApp</li>




                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>Entertainment</td>
                    <td>
                      <ul>
                        <li>Booking movie/theatre tickets online: BookMyShow</li>
                        <li>Watching movies online : YouTube, Netflix, Prime Video, Hotstar, Voot</li>
                        <li>News apps: Inshorts, Daily Hunt</li>
                        <li>Storytel, Audible, BookGanga</li>
                        <li>Smart Home: Alexa, Google Home</li>
                        <li>Casting (Mobile on TV)</li>
                        <li>Online Music: Gaana, JioSaavn</li>

                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>Cashless Transactions</td>
                    <td>
                      <ul>
                        <li>Google Pay</li>
                        <li>Paytm</li>
                        <li>BHIM App</li>

                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>eBanking</td>
                    <td>
                      <ul>
                        <li>Opening net banking account</li>
                        <li>Credit or debit card for online shopping</li>
                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>Bill Payment/ Recharge</td>
                    <td>
                      <ul>
                        <li>Recharge mobile phone online</li>
                        <li>Pay Telephone bill online</li>
                        <li>Pay electricity bill online </li>

                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>Travel</td>
                    <td>
                      <ul>
                        <li> Travel Planning: Yatra, MakeMyTrip, Trivago, Google Trip</li>
                        <li>Railway Booking: IRCTC</li>
                        <li> Flight tracking: Flight Radar</li>
                        <li>Booking Cabs online: OLA, Uber</li>
                        <li> mParivahan</li>

                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>Navigation</td>
                    <td>
                      <ul>
                        <li>Google Maps, GPS, Here Maps</li>

                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>New Media Literacy</td>
                    <td>
                      <ul>
                        <li>Image Editing, Audio Editing, Video Editing, Short clips, Facebook videos, Instagram videos</li>
                        <li> Google Photos, Musemaze, Kinemaster</li>
                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>File Sharing</td>
                    <td>
                      <ul>
                        <li>Transfer using Bluetooth, ShareIt, WeTransfer</li>

                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>eCommerce</td>
                    <td>
                      <ul>
                        <li>Online Shopping</li>
                        <li>Amazon, Flipkart, Myntra, AJIO, Snapdeal</li>
                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>Utilities</td>
                    <td>
                      <ul>
                        <li>Utility services: Urban Company</li>
                        <li>Quickr</li>
                        <li>Buy and sell: OLX</li>

                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>Backup and Recovery</td>
                    <td>
                      <ul>
                        <li> Mobile Data Backup</li>
                        <li>Contact/SMS Backup</li>
                        <li>eWallets</li>
                        <li>Digital Wallets</li>
                        <li>SMS Organizer</li>


                      </ul>
                    </td>
                  </tr >
                  <tr>
                    <td>Security</td>
                    <td>
                      <ul>
                        <li> FaceID</li>
                        <li> Biometric Authentication</li>
                        <li>PINs</li>
                        <li>Emergency Number (ICE)</li>


                      </ul>
                    </td>
                  </tr >


                </tbody >
              </Table >
              <h4>21st Century Study Skills</h4>
              <Table bordered>
                <thead>
                  <tr>
                    <th>Topics</th>
                    <th>Sub-Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Smart Search</td>
                    <td>
                      <ul>
                        <li>Using Google to search more information about study topics</li>
                        <li>Doing clustered search</li>
                        <li>Using Wikipedia to search the information</li>
                        <li>Searching and downloading eBooks (NCERT)</li>
                        <li>Finding information about The World via https://knoema.com/atlas</li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td>Online and Free Learning</td>
                    <td>
                      <ul>
                        <li>Watching educational videos online (YouTube)</li>
                        <li>Watching educational talks on TED Talks</li>
                        <li>Listening to a podcast and learn cool science facts in 60 seconds</li>
                        <li> Joining Massive Open Online Courses (MOOCs)</li>
                        <li> Learning online courses on Coursera.org</li>
                        <li>Learning online courses on Udemy App</li>
                        <li>Learning any subject online for free on edx</li>
                        <li>Learning from Best Colleges in the World - NPTEL</li>
                        <li>Learning through videos on Khan Academy</li>
                        <li>I want to improve my Social Learning/General Knowledge using Facebook</li>
                        <li>Using Discovery Science for studying in a better way</li>
                        <li>Learning programming/coding with peers on www.codecademy.com</li>
                        <li>I can access online Research Papers (Google Scholar)</li>
                        <li>I can participate in Live Discussions (Facebook Live)</li>
                        <li>I can learn by discussions in forums (quora.com)</li>
                        <li> Listening to music, watch videos and share online</li>
                        <li> Learning through Edmodo</li>
                        <li> Learning online courses on Moodle</li>


                      </ul>

                    </td>
                  </tr>
                  <tr>
                    <td>Notes Making and Presentation</td>
                    <td>
                      <ul>
                        <li>Using Google Docs to share notes</li>
                        <li> Organizing my day/ Notes, important points using Google Keep</li>
                        <li> Making a presentation on my research and take real time feedback via Google Slides</li>
                        <li>Express my Ideas using Mindmap tool</li>
                        <li> Checking my project report for Plagiarism using Plagiarism checker</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Collaboration and Data Organization </td>
                    <td>
                      <ul>
                        <li>Collaborating with peers to practice for competitive exams like IIT JEE</li>
                        <li>Conduct a poll/survey/research using Google Forms</li>
                        <li>Improving my productivity using StayFocusd app</li>
                        <li>Keeping track of my important events/classes all in one place (Google Calendar)</li>


                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Language Learning </td>
                    <td>
                      <ul>
                        <li>Searching synonyms, antonyms, and thesaurus on dictionary.com</li>
                        <li>Checking grammar and spell check</li>
                        <li>Improving vocabulary using volt</li>
                        <li>Listening to Online Stories / Classic Literature in any language</li>
                        <li> Learning a new language by interacting with my phone with the duoLingo App</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Art, History and Humanities</td>
                    <td>
                      <ul>
                        <li>Learning about History using Google Arts and Culture</li>
                        <li>Learning about the History of India, using India History App chronologically</li>
                        <li>Drawing art on a Tablet using an app</li>


                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Learning through Experiments, Games </td>
                    <td>
                      <ul>
                        <li> Performing science experiments online- Physics</li>
                        <li>Performing science experiments online– Chemistry</li>
                        <li>Performing Math Experiments</li>
                        <li>Learning about the stars by using http://stars.chromeexperiments.com/</li>
                        <li>Testing Intelligence Quotient (IQ)</li>
                        <li>Testing Emotional Quotient (EQ)</li>
                        <li>Understanding my personality type - https://www.16personalities.com/</li>
                        <li>Learning by playing games and improve my abilities - Elevate</li>
                        <li>Learning by playing games and improve my abilities – NeuroNation</li>
                        <li>Exploring http://planner5d.com/ for interior plans</li>

                      </ul>
                    </td>
                  </tr>


                </tbody>
              </Table>
            </div>
          </AccordionBody>
        </AccordionItem>
      </Accordion>


      {/* <h4>21st Century Office Productivity Skills</h4> */}

      <Accordion open={open} toggle={toggle} className="mb-2">
        <AccordionItem>
          <AccordionHeader targetId="10">Digital India Skills</AccordionHeader>
          <AccordionBody accordionId="10">
            <div style={{ overflowX: 'auto' }}>
              <Table bordered>
                <thead>
                  <tr>
                    <th>Topics</th>
                    <th>Sub-Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Jobs/Self-Employment Opportunities</td>
                    <td>
                      <ul>
                        <li> Applying for BharatNet connectivity (BBNL Dark Fiber)</li>
                        <li> Document digitisation through Digital India Platform</li>
                        <li> Using Digilocker to store certificates online (National Academic Depository)</li>
                        <li> Scanning and storing documents online</li>
                        <li>  Searching and applying for jobs at National Career Service portal</li>
                        <li>Booking an appointment with Career Counsellor at National Career Service portal</li>
                        <li>Applying for Udyam Aadhaar, Shop act licence</li>

                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td>New Company Formation or Entreprenuership</td>
                    <td>
                      <ul>
                        <li> Applying online for Start-up Recognition</li>
                        <li>Replace manual paper based signatures by adding eSign (Electronic Signature)</li>
                        <li> Applying for Village Level Entrepreneur (VLE) for Common Service Center CSCs</li>
                        <li> Applying online for Pradhanmantri Mudra Yojana</li>

                      </ul>

                    </td>
                  </tr>
                  <tr>
                    <td>Government to Citizen (G2C)</td>
                    <td>
                      <ul>
                        <li>As GST Suvidha Provider (GSP) to help merchants in filing taxes</li>
                        <li>Registering new voters to the Election Commission Services (ECS) database</li>
                        <li>Searching name in the Voter ID list</li>
                        <li>Correcting data of the voters in Election Commission Services (ECS) database</li>
                        <li>Applying for PAN Card</li>
                        <li>Applying for Aadhaar Card, verifying and updating Aadhaar Details</li>
                        <li>Applying for Passport and Tracking status of my Passport application online</li>
                        <li> Applying online for Age Nationality Domicile</li>
                        <li>Applying online for Income Certificate</li>
                        <li>Applying online for Caste Certificate</li>
                        <li>Applying online for Certificate of Registration of Marriage</li>
                        <li>Applying online for Below Poverty Line Certificate</li>
                        <li>Applying for Birth Certificate online</li>
                        <li>Applying for Death Certificate online</li>
                        <li>Applying online for Water Connection</li>
                        <li>Applying for ration card online</li>
                        <li>Using online government helpline services</li>
                        <li>Getting alerts from Central Government</li>
                        <li>Viewing details on MGNREGA</li>
                        <li>Availing ePost Office Service of India Post</li>
                        <li> Checking likely eligibility for various Government welfare schemes</li>
                        <li>Using Government sites to pay Bills, taxes</li>
                        <li>Getting online 7/12</li>
                        <li> Applying for Pradhan Mantri Awas Yojana</li>
                        <li> Applying online for Atal Pension Yojana</li>
                        <li> Applying online for Pradhanmantri Sukanya Samruddhi Yojana</li>
                        <li> Kiosk Banking through CSCs as Customer Service Points</li>
                        <li>Applying for FASTag</li>
                        <li>Enabling the road guidance and pleasant experience on toll plazas while travelling</li>
                        <li>Filing income tax return</li>
                        <li>Checking and Claiming/Withdrawing Provident Fund Online</li>
                        <li>Tracking status of the court case online</li>
                        <li>Booking an appointment with Government officer Online Booking</li>
                        <li> Checking availability and booking of LPG services online</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Government to Citizen (G2C) - Transportation </td>
                    <td>
                      <ul>
                        <li>Finding Vehicle Details</li>
                        <li>Applying online for Driving License</li>
                        <li>Renewal of Driving License</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>eCitizenship Services</td>
                    <td>
                      <ul>
                        <li>Mobile Recharge through Digital Seva Portal</li>
                        <li>Mobile Bill Payments through Digital Seva Portal</li>
                        <li>DTH Recharge through Digital Seva Portal</li>
                        <li>Booking railway tickets</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Banking</td>
                    <td>
                      <ul>
                        <li> Becoming aware about the Net Banking Services using mobile app</li>
                        <li>Applying for education loan</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>DigiPay </td>
                    <td>
                      <ul>
                        <li>Using DigiPay service</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Health Services </td>
                    <td>
                      <ul>
                        <li>Registering for Vaccination (COWIN)</li>
                        <li>Booking appointment online in Government Hospital</li>
                        <li>CSC Wellness Centers for providing health services to citizens</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Education </td>
                    <td>
                      <ul>
                        <li>Enrolling for eSkill India Programs</li>
                        <li> Using National Digital Library of India</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Scholarships </td>
                    <td>
                      <ul>
                        <li>Applying for National Scholarships</li>
                        <li>Applying for educational Scholarships through MahaDBT Portal<br />
                          - Government Vidyaniketan Scholarship<br />
                          - Post-Matric Scholarship to SBC Students<br />
                          - Tuition Fees and Examination Fees Scholarship to OBC Students<br />
                          - Eklavya Scholarship<br />
                          - Rajarshi Chhatrapati Shahu Maharaj Shikshan Shulkh Shishyavrutti Yojna<br />
                          - Open Merit Scholarship in Junior College</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Citizen's Participation </td>
                    <td>
                      <ul>
                        <li>Lodging Public Grievance on Centralized Public Grievance Redress And Monitoring System (CPGRAMS)</li>
                        <li> Providing citizen feedback at Crime and Criminal Tracking Network & Systems (CCTNS)</li>
                        <li> Registering complaints with National Human Rights Commission online</li>
                        <li> Registering complaints on Consumer Forum</li>
                        <li>Making an application for right to information</li>
                        <li>Filing online Police FIR</li>
                        <li> Reporting a cybercrime</li>
                        <li>Exploring 'mygov.in' and participating various contests</li>
                        <li>Contributing to and Using eGreeting templates from mygov.in</li>
                        <li>Ensuring clean city and premises</li>
                        <li>Registering as individual/organisational volunteer at Self4Society platform</li>
                        <li>Registering as individual/organisational volunteer at DigiSevak platform</li>
                        <li>Sharing your ideas, insights and thoughts with the Prime Minister of India using  https://www.pmindia.gov.in/</li>
                        <li>Volunteering in Young India initiatives led by Government of India</li>
                        <li>Posting a civic-related issue (e.g. a garbage dump) to the city corporation using The Swachhata-MoHUA app</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Agriculture</td>
                    <td>
                      <ul>
                        <li>Getting Soil Health card</li>
                        <li> Using mKisan Portal and Kisan App - Becoming aware about the Agricultural Market Price using mKisan App</li>
                        <li>Checking weather status in nearby area</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Insurance</td>
                    <td>
                      <ul>
                        <li>Applying online for Pradhanmantri Suraksha Bima Yojana</li>
                        <li>Applying online for Pradhanmantri Jeevan Jyoti Bima Yojana</li>
                        <li>Applying online for Pradhan Mantri Fasal Bima Yojana</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Social Welfare</td>
                    <td>
                      <ul>
                        <li>Using Rakshak App for safety of Women and Senior Citizens</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Agriculture</td>
                    <td>
                      <ul>
                        <li>Getting Soil Health card</li>
                        <li> Using mKisan Portal and Kisan App - Becoming aware about the Agricultural Market Price using mKisan App</li>
                        <li>Checking weather status in nearby area</li>
                      </ul>
                    </td>
                  </tr>


                </tbody >
              </Table >
            </div>
          </AccordionBody>
        </AccordionItem>
      </Accordion>

      {/* <h4>Digital India Skills </h4> */}
      <Accordion open={open} toggle={toggle} className="mb-2">
        <AccordionItem>
          <AccordionHeader targetId="11">Ergonomics</AccordionHeader>
          <AccordionBody accordionId="11">
            <div style={{ overflowX: 'auto' }}>
              <Table bordered>
                <thead>
                  <tr>
                    <th>Topics</th>
                    <th>Sub-Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Correct Sitting Postures<br></br> while using computer</td>
                    <td>
                      <ul>
                        <li>Importance of ideal posture while using computer</li>
                        <li>Some neck exercises for stress relief</li>
                        <li>Ideal neck Posture</li>
                        <li>Shoulder exercises for computer users</li>
                        <li>Leg exercises</li>
                        <li>Stretch your legs</li>
                        <li>Why use an ergonomic chair?</li>
                        <li>Use ergonomic Table</li>
                        <li>Ergonomic keyboard drawer</li>
                        <li> Avoid the Lower Back Pain</li>
                        <li>Prevent musculoskeletal disorders</li>
                        <li>Exercises for your back</li>
                        <li>Prevent ergonomic injuries in children</li>


                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td>Using Mouse and <br></br>Keyboard Correctly</td>
                    <td>
                      <ul>
                        <li>Correct use of keyboard and posture</li>
                        <li>Ergonomic keyboards</li>
                        <li>Tips to use the keyboard</li>
                        <li>Use Mouse Ergonomically</li>
                        <li>What is an ergonomic mouse?</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Taking Care of Eyes</td>
                    <td>
                      <ul>
                        <li>Eyes vis-a-vis your computer screen</li>
                        <li>Adjust the display’s brightness</li>
                        <li>Check and optimize the display settings</li>
                        <li>Rule of 20-20-20”</li>
                        <li>Prevent computer vision syndrome</li>
                        <li>Blink your eyes</li>
                        <li>Soothe your eyes</li>
                        <li>Proper lighting around computer workstation</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Taking Care of Ears </td>
                    <td>
                      <ul>
                        <li>Proper lighting around computer workstation</li>
                        <li>Avoiding high audio volume</li>
                        <li>Helpful tips: Reading from your computer screen</li>
                        <li>Using ergonomic headphones</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Taking Care of <br></br>Hands and Fingers</td>
                    <td>
                      <ul>
                        <li>Exercises your hands and fingers</li>
                        <li>Ouch! That wrist hurts!</li>
                        <li>Flex those fingers</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Forming good Habits</td>
                    <td>
                      <ul>
                        <li> Break the harmful habits</li>
                        <li> Adjust your workstation for comfort</li>
                        <li> Check the position of your monitor</li>
                        <li> Don’t keep those legs dangling</li>
                        <li> Correct laptop posture</li>
                        <li> Exercises at your desk</li>
                        <li> Avoid eating at your desk</li>
                        <li> Breathing exercises</li>
                        <li> Keep away from the noise</li>
                        <li> Taking care while working at AC workplaces</li>

                      </ul>
                    </td>
                  </tr>


                </tbody >
              </Table >
            </div>
          </AccordionBody>
        </AccordionItem>
      </Accordion>

      {/* <h4>Ergonomics </h4> */}
      <Accordion open={open} toggle={toggle} className="mb-2">
        <AccordionItem>
          <AccordionHeader targetId="12">Go Green</AccordionHeader>
          <AccordionBody accordionId="12">
            <div style={{ overflowX: 'auto' }}>
              <Table bordered>
                <thead>
                  <tr>
                    <th>Topics</th>
                    <th>Sub-Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Saving Energy</td>
                    <td>
                      <ul>
                        <li>Importance of shutting down and logging off a computer</li>
                        <li>Turn off your monitor</li>
                        <li>Did you correctly shutdown your computer?</li>
                        <li>Hibernate, lock or shut down?</li>
                        <li>Screensavers are not energy savers, shun them</li>
                        <li>Use apps to save time and fuel</li>
                        <li>Use Google Maps to save fuel and time</li>
                        <li>Save fuel, go green</li>
                        <li>Tips on green computing</li>
                        <li>Use shared drive storages instead of email attachments</li>
                        <li>Analyze your computer's energy usage</li>
                        <li>Use effective power management</li>
                        <li>When multitasking, close the unused apps</li>
                        <li>Organize files and folders: Saves energy</li>
                        <li>Use energy saving technology</li>
                        <li>Buy computers that come with a Star rating</li>
                        <li>Buy only energy efficient products</li>
                        <li>Upgrade to a flat panel LCD monitor</li>
                        <li>Adjust the brightness on your monitor</li>
                        <li>Remember to turn-off the Bluetooth and Wi-Fi</li>
                        <li>Turn off the peripherals</li>
                        <li>Verify if your computer’s power supply is 80 plus Certified</li>
                        <li>Extend the life of your computer</li>



                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td>Paperless Working</td>
                    <td>
                      <ul>
                        <li> Save paper, use the Notepad app</li>
                        <li> Send e-invites and save paper</li>
                        <li>Reduce your carbon footprints</li>
                        <li>Share online and reduce paper waste</li>
                        <li>Save paper, use both sides of paper</li>
                        <li>Use paperless communication</li>
                        <li>Use online services wherever possible</li>
                        <li>Think before you take a printout</li>
                        <li>Reduce paper margins to decrease paper consumption</li>
                        <li>Use soft copies of textbooks whenever possible</li>
                        <li>Use digital copies over hard copies</li>
                        <li> Opt for e-bills and e-bank statements to save environment</li>
                        <li>Use printer rationally, opt for eFax</li>
                        <li>Replace colored prints with black and white</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Saving Resources</td>
                    <td>
                      <ul>
                        <li>Use Google Calendar to work effectively</li>
                        <li>Create shortcuts, not copies</li>
                        <li>Avoid unnecessary digital storage and email attachments</li>
                        <li>Delete unused files from the hard drive</li>
                        <li>Archive large email folders</li>
                        <li>Avoid non-productive message and mail forwards</li>
                        <li>Use zip files and PDFs</li>
                        <li>Video conference to save time and resources</li>
                        <li>Download only the apps and programs you need</li>

                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Recycling</td>
                    <td>
                      <ul>
                        <li>Recycle your old computer</li>
                        <li>Separate your e-waste and techno trash</li>
                        <li>Reuse ink cartridges</li>

                      </ul>
                    </td>
                  </tr>

                </tbody >
              </Table >

              <h4>Netiquettes</h4>
              <Table bordered>
                <thead>
                  <tr>
                    <th>Topics</th>
                    <th>Sub-Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Netiquettes</td>
                    <td>
                      <ul>
                        <li>Netiquettes</li>
                        <li>Email etiquettes</li>
                        <li>Online forms and their risks</li>
                        <li>Be vigilant while using online classifieds</li>
                        <li>Rules of Net-etiquettes</li>
                        <li> Sharing is caring, but not on Internet</li>
                        <li> Deactivate unused accounts</li>
                        <li>Safe online recharge</li>
                        <li>Risks in Online registration</li>
                        <li>Validate before sharing online</li>
                        <li>If you copy-paste, first know about copyrights</li>
                        <li> Importance of strong password</li>
                        <li>Sharing photos online</li>
                        <li>Safe Downloading</li>
                        <li>Stay safe on social networking sites</li>
                        <li>Surf smarter</li>
                        <li>Digital signatures</li>
                        <li>Be safe while posting your resume online</li>
                        <li>Trusted websites</li>
                        <li>Cyber Hacking</li>
                        <li>Cyber Mischief</li>
                        <li>Cyber Stalking</li>
                        <li>Cheating by personation</li>
                        <li>Cyber Identity Fraud</li>
                        <li>Some safe e-commerce tips</li>
                        <li>Keep your software/apps updated</li>
                        <li>Be vigilant while using online classifieds</li>
                        <li>Just because it’s free, it doesn’t mean it’s safe</li>


                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td>Smart Habits</td>
                    <td>
                      <ul>
                        <li> Encrypt files to protect data</li>
                        <li> Online gaming is not always fun!</li>
                        <li>Keep your account information for yourself</li>
                        <li>Use antivirus protection before you go online</li>
                        <li>Protect yourself from cyber bullying</li>
                        <li>Stay safe while booking tickets online</li>
                        <li>Create back-up copies for your important stuff</li>
                        <li>Sharing is caring, but not on the Internet</li>
                        <li>Unsecure wireless connections</li>
                        <li>Peer to peer sharing</li>
                        <li>Keep your data private online</li>
                        <li> Surf smarter</li>
                        <li> Don't leave copies of your printed pages in a common printer</li>
                        <li>Use emoticons in your post</li>
                        <li> Don't Type in ALL CAPS</li>
                        <li>Read the email before you send</li>
                        <li>Risks associated with social bookmarking</li>
                        <li>Unsecured wireless connections</li>
                        <li>Do not attach unnecessary files</li>
                        <li>Don't reply a private message on "reply all”</li>


                      </ul>
                    </td>
                  </tr>

                </tbody >
              </Table >

            </div>
          </AccordionBody>
        </AccordionItem>
      </Accordion>



      {/* <h4>Go Green </h4> */}
      <Accordion open={open} toggle={toggle} className="mb-2">
        <AccordionItem>
          <AccordionHeader targetId="13">Cyber Security Skills</AccordionHeader>
          <AccordionBody accordionId="13">
            <div style={{ overflowX: 'auto' }}>
              <Table bordered>
                <thead>
                  <tr>
                    <th>Topics</th>
                    <th>Sub-Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Cyber Security Skills</td>
                    <td>
                      <ul>
                        <li>Managing and maintaining strong passwords</li>
                        <li>Securing online banking transactions and taking care of information safety</li>
                        <li>Setting Emergency Text on ANDROID phone</li>
                        <li>Tracking the data (internet) usage on Android PHONE</li>
                        <li>Using good antivirus software for my Laptop and PC</li>
                        <li>Securing Profile and other pictures shared on Facebook</li>
                        <li>Using App Locker tools for important Mobile Apps</li>
                        <li> Restricting Administrator account access on Personal Laptops</li>
                        <li>"Safely remove hardware option” for plug and play devices</li>
                        <li>Legal aspects of fake Profiles on Social Media Sites</li>
                        <li>Securing WhatsApp DP</li>
                        <li>Awareness about Legal aspects of publishing/transmitting material containing sexually explicit conducts</li>
                        <li> Awareness about defamation through social media and it’s legal implications</li>
                        <li>Awareness about frauds and cheating through matrimonial sites</li>
                        <li>Using Login IDs and passwords on public computers using safety tips</li>
                        <li>Be careful while Sharing and Forwarding on social media</li>
                        <li> Prevent/Block the appearance of unwanted Ads and Pop-ups</li>
                        <li>Importance of using a physical lock for laptop</li>
                        <li> Checking the warranty of a product or gadget</li>
                        <li>Importance of noting down the IMEI Code</li>
                        <li> Avoid malware while downloading Android apps</li>
                        <li>Blocking of my SIM card when handset is lost</li>
                        <li>Awareness about the legal consequences of using cracked or pirated software</li>
                        <li> Protecting yourself from fake emails which pretend to be genuine</li>
                        <li> Secure net banking and online transactions on public computers</li>
                        <li>Awareness about data theft and IT Act 2000</li>
                        <li>Awareness about Online Sexual harassments and it’s Legal implications</li>
                        <li>Protecting yourself from online lottery cheating and fake messages </li>

                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td>Smart Habits</td>
                    <td>
                      <ul>
                        <li>Protection from 'Work from Home' scams</li>
                        <li>Protection from social media blackmailing</li>
                        <li>Awareness of consequences of downloading unknown Email attachments and safety tips</li>
                        <li>Securing Debit/Credit card physically</li>
                        <li>Awareness about the legal consequences of displaying and distributing pirated music/videos</li>
                        <li>Protecting data in case of loss or theft of computer/laptop</li>
                        <li>Steps to follow whenever Mobile is stolen/lost</li>
                        <li>Using safety tips for using public Wi- Fi networks</li>
                        <li>Securing Aadhaar card data</li>
                        <li>Awareness about the hazards of playing online mobile games</li>
                        <li>Avoid peeping while using passwords and PINs</li>
                        <li> Using the safety tips while taking selfies</li>
                        <li>Awareness about legal consequences about data tampering</li>
                        <li>Awareness about the hazards of using mobile while walking or driving a vehicle on road</li>
                        <li>Awareness about the legal aspects of offence like internet and drug trafficking</li>
                        <li>Protect yourself while travelling by a hired car</li>
                        <li>Identifying and protecting from fraud calls regarding online lucky draw</li>



                      </ul>
                    </td>
                  </tr>

                </tbody >
              </Table >
            </div>
          </AccordionBody>
        </AccordionItem>

      </Accordion>


      {/* <h4>Cyber Security Skills</h4> */}
      <Accordion open={open} toggle={toggle} className="mb-2">
        <AccordionItem>
          <AccordionHeader targetId="14">Job Readiness Skills</AccordionHeader>
          <AccordionBody accordionId="14">
            <div style={{ overflowX: 'auto' }}>
              <Table bordered>
                <thead>
                  <tr>
                    <th>Topics</th>
                    <th>Sub-Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Job Readiness Skills</td>
                    <td>
                      <ul>
                        <li>Job Readiness and Digital Freelancing</li>
                        <li>Careers in Digital Freelancing</li>
                        <li>Use of Mobile for Digital Freelancing</li>
                        <li>Internet for Digital Freelancing</li>
                        <li>Mobile Data and Hotspot</li>
                        <li>Creating Professional email ID</li>
                        <li>Security for email account</li>
                        <li>Retrieving lost password for email account</li>
                        <li>Resume: Do’s and Don’ts</li>
                        <li>Various Job portals</li>
                        <li>Apply for suiTable online jobs</li>
                        <li>Create Professional Network on LinkedIn</li>
                        <li>Digilocker: Store your documents online</li>
                        <li>Google Drive for storage</li>
                        <li>Communication and Etiquettes</li>
                        <li>Gboard: Google Keyboard</li>
                        <li>Grammarly</li>
                        <li>Voice typing using Google Docs</li>
                        <li>Notes taking using Google Keep</li>
                        <li>Securing net banking transactions</li>
                        <li>Use of Paytm and BHIM for Cashless transaction</li>
                        <li>Use of PayPal</li>
                        <li>Job opportunities on Freelancing portals</li>


                      </ul>
                    </td>
                  </tr>



                </tbody >
              </Table >
            </div>
          </AccordionBody>
        </AccordionItem>
      </Accordion>
      <hr />

      {/* <h4>Job Readiness Skills</h4> */}

      <div>
        <h5>Software Tools</h5>
        <Table bordered >
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Tools</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="2" style={{
                backgroundColor: '#bfc6cd', // Light background color
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' // Simple box shadow
              }}>Operating System and Internet</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Windows 10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internet</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Google Chrome</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Mozilla Firefox</td>
            </tr>
            <tr>
              <td colSpan="2" style={{
                backgroundColor: '#bfc6cd', // Light background color
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' // Simple box shadow
              }}>Word Processor</td>
            </tr>
            <tr>
              <td>5</td>
              <td>MS Word 2019</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Google Docs</td>
            </tr>
            <tr>
              <td colSpan="2" style={{
                backgroundColor: '#bfc6cd', // Light background color
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' // Simple box shadow
              }}>Spreadsheet</td>
            </tr>
            <tr>
              <td>7</td>
              <td>MS Excel 2019</td>
            </tr>
            <tr>
              <td>8</td>
              <td>Google Sheets</td>
            </tr>
            <tr>
              <td colSpan="2" style={{
                backgroundColor: '#bfc6cd', // Light background color
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' // Simple box shadow
              }}>Presentation Graphics</td>
            </tr>
            <tr>
              <td>9</td>
              <td>MS PowerPoint 2019</td>
            </tr>
            <tr>
              <td>10</td>
              <td>Google Slides</td>
            </tr>
            <tr>
              <td colSpan="2" style={{
                backgroundColor: '#bfc6cd', // Light background color
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' // Simple box shadow
              }}>Personal Information Manager</td>
            </tr>
            <tr>
              <td>11</td>
              <td>MS Outlook 2019</td>
            </tr>
            <tr>
              <td>12</td>
              <td>Gmail Inbox</td>
            </tr>
            <tr>
              <td>13</td>
              <td>Google Drive</td>
            </tr>
            <tr>
              <td colSpan="2" style={{
                backgroundColor: '#bfc6cd', // Light background color
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' // Simple box shadow
              }}>Other Essentials Tools</td>
            </tr>
            <tr>
              <td>14</td>
              <td>Several Apps on Smart Phones</td>
            </tr>
          </tbody>
        </Table>
      </div>

      <hr />

      <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    

  );
}
export default CertificateInformation